import { CarListingData, SortingOptions } from '@/types';

const relevanceSort = (objects: CarListingData[]): CarListingData[] => {
    return objects.sort((a, b) => {
        if (a.isPurchaseInProgress && !b.isPurchaseInProgress) {
            return 1;
        }

        if (!a.isPurchaseInProgress && b.isPurchaseInProgress) {
            return -1;
        }

        if (a.isNewlyAdded && !b.isNewlyAdded) {
            return -1;
        }

        if (!a.isNewlyAdded && b.isNewlyAdded) {
            return 1;
        }

        return 0;
    });
};
export const sortCars = (
    cars: CarListingData[],
    sortingOptions?: SortingOptions
) => {
    const sortedCars = [...cars];
    if (!sortingOptions?.field) {
        return relevanceSort(sortedCars);
    }

    const sortBy = sortingOptions.field;
    if (!sortBy) return relevanceSort(sortedCars);
    if (sortingOptions.asc) {
        sortedCars.sort((a, b) => Number(a[sortBy]) - Number(b[sortBy]));
    } else {
        sortedCars.sort((a, b) => Number(b[sortBy]) - Number(a[sortBy]));
    }

    return sortedCars;
};
